<template>
	<div class="product-selection">
		<div class="product-selection-list row py-2">
			<template v-for="(product, index) in products" :key="product.id">
				<div v-if="isFirstWithCompatMessage(index)" class="col-12">
					<hr>
					<h5>Selecting these options will change other options you've selected.</h5>
				</div>
				<div class="product-selection-list-item col-lg-4 col-6">
					<ProductCard v-bind="product" :fieldId="fieldId" @update-selection="handleUpdateSelection"></ProductCard>
				</div>
			</template>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ProductCard from './ProductCard.vue'

const props = defineProps(['products', 'fieldId'])

let firstCompatibleIndex = computed(() => {
	return props.products.findIndex(product => product?.compatibilityMessage)
})

let isFirstWithCompatMessage = (index) => {
	return index === firstCompatibleIndex.value
}

const emits = defineEmits(['update-route', 'update-selection'])

const handleUpdateSelection = async(selection: any) => {
	await emits('update-selection', { ...selection });
}


</script>
